import { render } from "./GymDance.vue?vue&type=template&id=04571dd9&scoped=true"
import script from "./GymDance.vue?vue&type=script&lang=js"
export * from "./GymDance.vue?vue&type=script&lang=js"

import "./GymDance.vue?vue&type=style&index=0&id=04571dd9&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04571dd9"]])

export default __exports__